import type { IQuickActionUser } from '@common/microservice-types/db/quick-action/quick-action.user';
import type { IUserSkill } from '@common/microservice-types/db/skill/skill.user';
import type { IChatSetting } from '@core/types/chat-setting.types';
import { BehaviorSubject, Observable } from "rxjs";

export abstract class ChatSettingBase
{
    public abstract $getSetting(): Observable<IChatSetting>;
    public abstract getSetting(): IChatSetting;
    public abstract getSettingOriginal<T>(): T;
    public abstract setSetting(newSetting: IChatSetting): IChatSetting;
    public abstract getQuickActionsDefault(): IQuickActionUser[];
    public abstract $getQuickActions(): Observable<IQuickActionUser[]>;
    public abstract setQuickActions(quickActions: IQuickActionUser[]): IQuickActionUser[];
    public abstract $getSkills(): Observable<IUserSkill[]>;
    public abstract setSkills(skills: IUserSkill[]): IUserSkill[];
    public abstract isDefaultSkill(skill: IUserSkill | null): boolean;
    public abstract setCurrentSkill(skill: IUserSkill | null): void;
    public abstract getCurrentSkill(): IUserSkill | null;
    public abstract $getCurrentSkill(): Observable<IUserSkill | null>;

    private currentQuickAction: BehaviorSubject<IQuickActionUser | null> = new BehaviorSubject<IQuickActionUser | null>(null);
    private webSearch: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    private imageModel: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    private copilotId: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);
    public onDestroy(): void { }

    public setCurrentQuickAction(quickAction: IQuickActionUser | null): void
    {
        if (quickAction) { this.setCurrentSkill(null); }
        this.currentQuickAction.next(quickAction);
    }

    public getCurrentQuickAction(): IQuickActionUser | null
    {
        return this.currentQuickAction.getValue();
    }

    public $getCurrentQuickAction(): Observable<IQuickActionUser | null>
    {
        return this.currentQuickAction.asObservable();
    }

    public setWebSearch(value: boolean): void
    {
        this.webSearch.next(value);
    }

    public getWebSearch(): boolean
    {
        return this.webSearch.getValue();
    }

    public $getWebSearch(): Observable<boolean>
    {
        return this.webSearch.asObservable();
    }

    public setImageModel(apiName: string): void
    {
        this.imageModel.next(apiName);
    }

    public getImageModel(): string | null
    {
        return this.imageModel.getValue();
    }

    public $getImageModel(): Observable<string | null>
    {
        return this.imageModel.asObservable();
    }

    public setCopilotId(id: string): void
    {
        this.copilotId.next(id);
    }

    public getCopilotId(): string | null
    {
        return this.copilotId.getValue();
    }

    public $getCopilotId(): Observable<string | null>
    {
        return this.copilotId.asObservable();
    }
}
